const SortButton = ({ children, active, onClick }: SortButtonProps) => (
  <button
    onClick={onClick}
    className={`text-nav-item font-medium leading-tight tracking-wide capitalize transition-colors cursor-pointer ${
      active ? 'text-text' : 'text-text-secondary hover:text-primary'
    }`}
  >
    {children}
  </button>
);

export default SortButton;

type SortButtonProps = {
  children: React.ReactNode;
  active: boolean;
  onClick: () => void;
};
